import apiService from './api-service'

const configsService = {}

/**
 * Retrieve a configs by it's id
 * @param  array params (optional)
 * @return configs
 */
configsService.list = function (params) {
  return apiService.get(`/configs`, { params }).then(res => res.data)
}

/**
 * Retrieve a configs by it's id
 * @param  int id
 * @param  array params (optional)
 * @return configs
 */
configsService.getById = function (id) {
  return apiService.get(`/config/${id}`, { id }).then(res => res.data).catch(error => error)
}

/**
 * Retrieve a configs by it's name
 * @param  string name
 * @param  array params (optional)
 * @return configs
 */
configsService.getByName = function (name) {
  return apiService.get(`/config/${name}`, { name }).then(res => res.data).catch(error => error)
}

/**
 * Update a configs by it's id
 * @param  int id
 * @param  array params (optional)
 * @return configs
 */
configsService.updateById = function (id, body) {
  body['_method'] = 'PUT'
  return apiService.put(`/config/${id}`, body).then(res => res.data)
}

/**
 * Create a configs
 * @param  object body
 * @return configs
 */
configsService.post = function (body) {
  return apiService.post(`/config`, body).then(res => res.data)
}

export default configsService



// WEBPACK FOOTER //
// ./src/services/configs.js